import { useMemo } from "react";
import { shallowEqual, useSelector } from "react-redux";
import useOmnitureSetup from "./useOmnitureSetup";
import useCommonOmnitureData from "./useCommonOmnitureData";
import { useSearchParams } from "next/navigation";
import { getOutOfStock } from "../../utils/pdp/nonDeliverable";
import isEmpty from "lodash.isempty";
import { getLocalStorageItem, setLocalStorageItem } from "../../utils/storage/localStorageUtil";
import { isJsonString } from "../../utils/common";
/**
 * PDP page setup
 */
export default function usePDPOmnitureSetup(breadCrumbs, pageCategoryURL) {
  let pageCategory = "";
  const searchParams = useSearchParams();
  const { rootGeoId, catalogId, checkLoginInfo, isMobile } = useCommonOmnitureData();
  const { product } = useSelector(
    (state) => ({
      product: state?.pdp?.clientCurrentClickedItem,
    }),
    shallowEqual,
  );
  const searchOptions = Object.fromEntries(searchParams.entries());
  const isProductStockAvailable = !getOutOfStock(product?.productStockAvailable, product?.productId);
  const getProductCategoryData = getLocalStorageItem("pageCategoryIds");
  const parseData = isJsonString(getProductCategoryData) ? JSON.parse(getProductCategoryData) : {};

  if (product?.productId) {
    const isPageCategoryMatch =
      pageCategoryURL?.pathname?.includes("-lp") || parseData?.[product.productId] === pageCategoryURL?.pathname;

    if (isPageCategoryMatch) {
      pageCategory = pageCategoryURL?.pathname;
      parseData[product.productId] = pageCategoryURL.pathname;
    } else {
      delete parseData?.[product.productId];
    }
    setLocalStorageItem("pageCategoryIds", JSON.stringify(parseData));
  }

  const omniData = useMemo(
    () => ({
      userDetails: {
        checkLoginInfo,
      },
      appConfigs: {
        rootGeoId,
        catalogId,
        isMobile,
      },
      productDetail: {
        product,
        pageCategory: pageCategory || "",
        breadCrumbs,
        searchOptions,
        isProductStockAvailable,
        selectedVariant: product?.productId,
      },
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [catalogId, checkLoginInfo, rootGeoId, breadCrumbs, searchOptions, isProductStockAvailable, product?.productId],
  );

  useOmnitureSetup(omniData, [omniData?.userDetails?.checkLoginInfo], !isEmpty(omniData?.productDetail?.product));
}
